import googleMaps from 'utils/googleMaps';
import $ from 'jquery';

export default function configContattiPage() {
	$('.js-map-wrapper').each((i, el) => {
		const $map = $(el).find('.js-map-data');
		let dataSplitted = $map.data('mapsetting');
		if (dataSplitted) {
			dataSplitted = dataSplitted.split(',');
		}
		googleMaps($map[0], dataSplitted[0].replace('@', ''), dataSplitted[1], dataSplitted[2]);
	});
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/configPage/contatti.js
 **/